(function(){
  function hydrate(root){
    if (!root || root.__hydrated) return;
    root.__hydrated = true;
    var lazyImgs = root.querySelectorAll ? root.querySelectorAll('img[loading="lazy"]') : [];
    for (var i = 0; i < lazyImgs.length; i++) {
      var im = lazyImgs[i];
      if (im.complete) continue;
      im.decoding = im.decoding || 'async';
    }
  }
  document.addEventListener('shopify:section:load', function(e){ hydrate(e.target); });
  document.addEventListener('DOMContentLoaded', function(){ hydrate(document); });
  window.__lazyHydrate = hydrate;
})();
